/**
 * DTOs
 */
import { IUserInfoDto } from '../../interfaces';

/**
 * Models
 */
import { UserInfoModel } from '../../models';

/**
 * Utility class for converting data transfer objects to domain models.
 * 
 * This mapper handles the conversion between API response format (DTOs with snake_case)
 * and the application's internal format (Models with camelCase). All conversions
 * should go through this class to maintain consistency.
 */
export class UserDtoMapper {

  /**
   * Converts a user information DTO from the API into a user information model.
   * 
   * The DTO comes from the API with properties like first_name and role_id.
   * The model provides camelCase properties like firstName and roleId that
   * are easier to work with in the application code.
   * 
   * @param dto - The user information data transfer object from the API
   * @returns A new user information model instance
   */
  public static toUserInfoModel(dto: IUserInfoDto): UserInfoModel {
    return new UserInfoModel(dto);
  }

}

